<div class="account-rent">

  <div>
    @switch (transactionStages[0]) {
      @case (TransactionStage.DRAFT) {
        <h1>Mes entretiens planifiés ({{ (myRentCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.CONFIRMED) {
        <h1>Mes réservations pour location ({{ (myRentCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.ONGOING) {
        <h1>Mes locations en cours ({{ (myRentCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.COMPLETED) {
        <h1>Mes locations complétées ({{ (myRentCars$  | async)?.length}})</h1>
      }
    }
  </div>

  @if (((myRentCars$ | async) == undefined ) || (myRentCars$ | async)!.length === 0 ) {
    <h6>
      <br />
      Aucun véhicule à louer
    </h6>
  }

  @if (((myRentCars$  | async) != undefined )) {
    <div class="cars-section">
      @for (car of (myRentCars$  | async)!; track car; let i = $index) {
        <div id="{{car.carId}}" class="car-section">
          <!-- <app-car-card-buyer
          [car]="car"
          [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
          [businessLine]="businessLine"
          [objectSource]="objectSource">
        </app-car-card-buyer>  -->
        <app-provider-offer-card-seller
          [offer]="car"
          [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
          [objectSource]="objectSource"
          >
        </app-provider-offer-card-seller>
      </div>
    }
  </div>
}
<!--
<div class="car-list" *ngIf="((myRentCars$  | async) !== undefined )">
  <div *ngFor="let car of myRentCars; index as i" id="{{car.carId}}" class="car-section">

    <app-car-card-account
      [car]="car"
      [businessLine]="businessLine"
      [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
    </app-car-card-account>

    <mat-accordion multi>

      <mat-expansion-panel [expanded]="car.bookings.length < 2">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4> Réservations en cours <span *ngIf="car.bookings != undefined">({{car.bookings.length}}) </span></h4>
            <button *ngIf="canNewBooking(car.bookings)"
              class="cta-button-rent"  mat-button (click)="openBookingDialog(car.carId, 0);$event.stopPropagation()">
              <mat-icon>add</mat-icon> Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-bookings
          [objectSource]="objectSource"
          [carId]="car.carId"
          [enableNew]="false">
        </app-bookings>

      </mat-expansion-panel>
    </mat-accordion>

  </div>
</div> -->

</div>

